import { Component, OnInit, Input, ComponentFactoryResolver } from '@angular/core';

import {
  IOrderDelivery,
  IOrderRequest,
  CHAT_MESSAGE_TYPE,
  CieUtilsModalManagerService,
  hasDeliveryDetails,
  ORDER_DELIVERY_METHODS
} from '@cakeiteasy/web-utils';

import { UiFullSizeImageComponent } from '../../modals/ui-full-size-image/ui-full-size-image.component';

/**Deprecated only for backward compatibility
 * later it should be removed */
@Component({
  standalone: false,
  selector: 'ui-order-request-pinned-message-old-version',
  templateUrl: './ui-order-request-pinned-message-old-version.component.html',
  styleUrls: [ './ui-order-request-pinned-message-old-version.component.scss' ]
})
export class UiOrderRequestPinnedMessageOldVersionComponent implements OnInit {
  @Input() orderRequest: IOrderRequest;
  @Input() deliveryOrder: IOrderDelivery;
  @Input() messageType: CHAT_MESSAGE_TYPE;
  @Input() requestCreatedDate: Date;

  public CHAT_MESSAGE_TYPE = CHAT_MESSAGE_TYPE;

  public showDeliveryDetails: boolean;
  public isToDoor: boolean;
  public isPickup: boolean;

  constructor(private _modalManager: CieUtilsModalManagerService,
              private _componentResolver: ComponentFactoryResolver) {
  }

  ngOnInit() {
    // a NO_DELIVERY order has neither an address nor a delivery date to pin
    this.showDeliveryDetails = hasDeliveryDetails(this.deliveryOrder);
    this.isToDoor = this.showDeliveryDetails && this.deliveryOrder.type === ORDER_DELIVERY_METHODS.DELIVERY_TO_DOOR;
    this.isPickup = this.showDeliveryDetails && this.deliveryOrder.type === ORDER_DELIVERY_METHODS.PICKUP;
  }

  public showImage(imgUrl: string): void {
    this._modalManager
      .show(UiFullSizeImageComponent, this._componentResolver, { imgUrl }, {
        windowClass: 'full-size-image-modal'
      })
      .catch(() => {
      });
  }
}
